import { Node } from 'tiptap';

export default class MergeValueNode extends Node {
  get name() {
    return 'merge_tag';
  }

  get schema() {
    return {
      attrs: {
        tagId: {
          default: '',
        },
        category: {
          default: '',
        },
        mergeKey: {
          default: '',
        },
        customName: {
          default: '',
        },
      },
      group: 'inline',
      inline: true,
      selectable: true,
      draggable: false,
      parseDOM: [
        {
          tag: 'span.merge-tag',
          getAttrs: dom => ({
            tagId: dom.getAttribute('tagId'),
            category: dom.getAttribute('category'),
            mergeKey: dom.getAttribute('mergeKey'),
            customName: dom.getAttribute('customName'),
          }),
        },
      ],
      toDOM: node => ['span', { ...node.attrs, class: 'merge-tag' }],
    };
  }
}
